import store from "../redux/store";
import { setApiData } from "../redux/roomSlice";

export const callAPI = () => {
    const state = store.getState();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const payload = JSON.stringify({
        modelo: state.roomData.model,
        cubierta: state.roomData.roof,
        exterior: state.roomData.exterior,
        acentoExt: state.roomData.extAccent,
        interior: state.roomData.interior,
        acentoInt: state.roomData.intAccent,
        extras: {
            descanso: state.roomData.extras.includes("0"),
            armarios: state.roomData.extras.includes("1"),
            fotovoltaica: state.roomData.extras.includes("2"),
            domotica: state.roomData.extras.includes("3"),
            iluminacion: state.roomData.extras.includes("4"),
        },
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: payload,
        redirect: "follow",
    };

    fetch(import.meta.env.VITE_API_URL, requestOptions)
    .then((response) => response.text())
    .then((result) => store.dispatch(setApiData(JSON.parse(result))))
    .catch((error) => console.log("Error en la conexión con el servicio de presupuestos."));
};
